module.exports = __webpack_public_path__ + "static/media/00021600.3be495c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/galery/00021600.jpg
// module id = 127
// module chunks = 0